import { dedupe } from '@exodus/atoms'
import { createFusionAtom } from '@exodus/fusion-atoms'

const createFavoriteAssetsAtom = ({ fusion, logger, config: { defaultValue } }) => {
  return dedupe(createFusionAtom({ fusion, logger, path: 'favoriteAssets', defaultValue }))
}

export default createFavoriteAssetsAtom
